import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Converts video URLs to embeddable format
 * Supports YouTube, Vimeo, and Google Drive
 */
export function convertToEmbeddableUrl(url: string): string {
  if (!url) return '';
  
  console.log('🔍 Converting URL:', url);
  
  // YouTube patterns
  const youtubePatterns = [
    /(?:https?:\/\/)?(?:www\.)?youtube\.com\/watch\?v=([a-zA-Z0-9_-]+)/,
    /(?:https?:\/\/)?(?:www\.)?youtu\.be\/([a-zA-Z0-9_-]+)/,
    /(?:https?:\/\/)?(?:www\.)?youtube\.com\/embed\/([a-zA-Z0-9_-]+)/
  ];
  
  for (const pattern of youtubePatterns) {
    const match = url.match(pattern);
    if (match && match[1]) {
      console.log('✅ YouTube match found:', match[1]);
      return `https://www.youtube-nocookie.com/embed/${match[1]}`;
    }
  }
  
  // Vimeo pattern
  const vimeoPattern = /(?:https?:\/\/)?(?:www\.)?vimeo\.com\/(\d+)/;
  const vimeoMatch = url.match(vimeoPattern);
  if (vimeoMatch && vimeoMatch[1]) {
    console.log('✅ Vimeo match found:', vimeoMatch[1]);
    return `https://player.vimeo.com/video/${vimeoMatch[1]}`;
  }
  
  // Google Drive pattern - convert /view to /preview
  // Handle URLs with query parameters like ?usp=sharing
  const googleDrivePattern = /(?:https?:\/\/)?drive\.google\.com\/file\/d\/([a-zA-Z0-9_-]+)(?:\/view)?/;
  const driveMatch = url.match(googleDrivePattern);
  
  console.log('🔍 Google Drive match result:', driveMatch);
  
  if (driveMatch && driveMatch[1]) {
    const embedUrl = `https://drive.google.com/file/d/${driveMatch[1]}/preview`;
    console.log('✅ Google Drive match found:', driveMatch[1], '→', embedUrl);
    return embedUrl;
  }
  
  console.log('⚠️ No pattern matched, returning original URL');
  return url;
}
